// removed by extract-text-webpack-plugin
module.exports = {"header":"src-components-Header----Header-module---header---2gV_n"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/Header.module.scss
// module id = 111
// module chunks = 58411574672382 144251824217401